import { RouteRecordRaw } from 'vue-router';

export enum SettingsRoute {
    General = 'settings-general',
    Entities = 'settings-entities',
    Billing = 'settings-billing',
    ApiKeys = 'settings-api-keys',
    Webhook = 'settings-webhook',
}

export const routes: RouteRecordRaw = {
    path: '/settings',
    component: () => import('./Settings.vue'),
    children: [
        {
            path: 'general',
            name: SettingsRoute.General,
            component: () => import('./General/General.vue'),
        },
        {
            path: 'entities',
            name: SettingsRoute.Entities,
            component: () => import('./Entities/Entities.vue'),
        },
        {
            path: 'billing',
            name: SettingsRoute.Billing,
            component: () => import('./Billing/Billing.vue'),
        },
        {
            // Issuing a key is what makes a bookkeeper account an Integrator (platform ADR 0032);
            // the API refuses everyone else with a 403.
            path: 'api-keys',
            name: SettingsRoute.ApiKeys,
            component: () => import('./ApiKeys/ApiKeys.vue'),
            meta: { accountTypes: ['bookkeeper'] },
        },
        {
            // Where an Integrator is told about the orders it placed (platform ADR 0040).
            path: 'webhook',
            name: SettingsRoute.Webhook,
            component: () => import('./Webhook/Webhook.vue'),
            meta: { accountTypes: ['bookkeeper'] },
        },
        {
            path: ':(.*)',
            redirect: { path: '/settings/general' },
        },
    ],
};
